import './Main.css'
import { createBrowserRouter, RouterProvider, useNavigate, Link } from 'react-router-dom';
import { Spacer, DragNDrop, EmptyElement, BackButton, PageNotFound, Spacer100, LoadingDocs } from './Utils';
import strs from './strings'
import thisCase from './case'; 
import React, { useEffect, useReducer, useState } from 'react';
import { getUser, setUser } from './firestore';
import { Button, TextField } from '@mui/material';
import { useAuth } from './context';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Select from 'react-select';
import { countries } from './countries';

const lang = strs.en;


export default function Profile() {
	const {resetPassword} = useAuth();
	const [alertString, setAlertString] = React.useState('');
	const [isVisible, setIsVisible] = React.useState('hidden');
	const [curUser, setCurUser] = useState(undefined);

const reducer = (state, action) => {
	console.log('action field', action.field);
	console.log('action value', action.value);
	if (action.field === 'dateOfBirth') console.log('action value again', action.value);
	switch (action.type) {
		case "SET_DATA":
			return action.data;
		case "EDIT":
			return { ...state, [action.field]: { ...state[action.field], editable: true } };
		case "UPDATE":
			console.log('updating formState');
			return { ...state, [action.field]: { ...state[action.field], value: action.value } };
		case "SUBMIT":
			return { ...state, [action.field]: { ...state[action.field], editable: false } };
		default:
			return state;
	}
};

	const [formState, dispatch] = useReducer(reducer, {});

	function showAlert() {
			setIsVisible('fade-in');
			setTimeout( () => {
				setIsVisible('');
				setTimeout( () => {
					setIsVisible('fade-out');
				}, 5000);
				
			}, 500);
	}



	useEffect( () => {
		const wrapperAsync = async () => {
			const user = await getUser();		
			console.log('user', user);
			setCurUser(user);
			const basicInfo = user?.basicInfo;
			const formattedData = Object.fromEntries(
				Object.entries(basicInfo).map(([key, value]) => [key, { value, editable: false }])
			);
			console.log('formattedData', formattedData);
			dispatch({type: "SET_DATA", data: formattedData});
			console.log('formState', formState);
			console.log('legalGenderOptions', lang.legalGenderOptions)
		}
		wrapperAsync();
	}
		, []
	);


	if (formState === {}) {
		return (
			<LoadingDocs />
		)
	}
	
	return (
	<div className='form-div'>
		<BackButton />
		<Spacer />
		<h2 className='primary-title'>{lang.profile}</h2>
		<Spacer />
			{
			<div className='center-flex'>
				<p className='p-gray'>{lang.noNeedToEdit}</p>
			</div>
			}
		<Spacer />
		<div className='animated-div'>
			<div className=''>
				<div class='profile-block'>

					<div>

					<label for='full-name' className='quad-title'>{lang.firstName} </label>
					</div>
					<TextField 
						size='small'
						value={formState?.firstName?.value}
						onChange={(e) => dispatch({ type: "UPDATE", field: 'firstName', value: e.target.value })}
						onKeyDown={(e) => e.key === "Enter" && dispatch({ type: "SUBMIT", field: 'firstName' })}
						disabled={!formState['firstName']?.editable}
					/>
					<Button 
						onClick={() => dispatch({ type: "EDIT", field: 'firstName' })} disabled={formState['firstName']?.editable}
						sx={{width: 150}}
					>{lang.edit}</Button>

					<div>
					<label for='middle-name' className='quad-title'>{lang.middleName} </label>
					</div>
					<TextField 
						size='small'
						value={formState?.middleName?.value}
						onChange={(e) => dispatch({ type: "UPDATE", field: 'middleName', value: e.target.value })}
						onKeyDown={(e) => e.key === "Enter" && dispatch({ type: "SUBMIT", field: 'middleName' })}
						disabled={!formState['middleName']?.editable}
					/>
					<Button 
						onClick={() => dispatch({ type: "EDIT", field: 'middleName' })} disabled={formState['middleName']?.editable}
						sx={{width: 150}}
					>{lang.edit}</Button>


					<div>
					<label for='last-name' className='quad-title'>{lang.lastName} </label>
					</div>
					<TextField 
						size='small'
						value={formState?.lastName?.value}
						onChange={(e) => dispatch({ type: "UPDATE", field: 'lastName', value: e.target.value })}
						onKeyDown={(e) => e.key === "Enter" && dispatch({ type: "SUBMIT", field: 'lastName' })}
						disabled={!formState['lastName']?.editable}
					/>
					<Button 
						onClick={() => dispatch({ type: "EDIT", field: 'lastName' })} disabled={formState['lastName']?.editable}
						sx={{width: 150}}
					>{lang.edit}</Button>

					<div>
					<label for='second-last-name' className='quad-title'>{lang.secondLastName} </label>
					</div>
					<TextField 
						size='small'
						value={formState?.secondLastName?.value}
						onChange={(e) => dispatch({ type: "UPDATE", field: 'secondLastName', value: e.target.value })}
						onKeyDown={(e) => e.key === "Enter" && dispatch({ type: "SUBMIT", field: 'secondLastName' })}
						disabled={!formState['secondLastName']?.editable}
					/>
					<Button 
						onClick={() => dispatch({ type: "EDIT", field: 'secondLastName' })} disabled={formState['secondLastName']?.editable}
						sx={{width: 150}}
					>{lang.edit}</Button>

					<div>
					<label for='passport-number' className='quad-title'>{lang.passportNumber} </label>
					</div>
					<TextField 
						size='small'
						value={formState?.passportNumber?.value}
						onChange={(e) => dispatch({ type: "UPDATE", field: 'passportNumber', value: e.target.value })}
						onKeyDown={(e) => e.key === "Enter" && dispatch({ type: "SUBMIT", field: 'passportNumber' })}
						disabled={!formState['passportNumber']?.editable}
					/>
					<Button 
						onClick={() => dispatch({ type: "EDIT", field: 'passportNumber' })} disabled={formState['passportNumber']?.editable}
						sx={{width: 150}}
					>{lang.edit}</Button>

			<label for='NIE' className='quad-title'>{lang.NIE} </label>
			<TextField 
				size='small'
				value={formState?.nie?.value}
				onChange={(e) => dispatch({ type: "UPDATE", field: 'nie', value: e.target.value })}
				onKeyDown={(e) => e.key === "Enter" && dispatch({ type: "SUBMIT", field: 'nie' })}
				disabled={!formState['nie']?.editable}
			/>
			<Button 
				onClick={() => dispatch({ type: "EDIT", field: 'nie' })} disabled={formState['nie']?.editable}
				sx={{width: 150}}
			>{lang.edit}</Button>


		<label for='date-of-birth' className='quad-title'>{lang.dateOfBirth} </label>

			<LocalizationProvider dateAdapter={AdapterDayjs}>
	{
		<DatePicker
			value={dayjs(formState?.dateOfBirth?.value)}	
			name="dateOfBirth"
			disabled={!formState['dateOfBirth']?.editable}
			onChange={(date) => {
				try {
					if (date && date.isValid()) {
						const isoDateString = date.toISOString();
						const event = { target: { name: 'dateOfBirth', value: date } };
						console.log('date', isoDateString);
						dispatch({type: "UPDATE", field: 'dateOfBirth', value: isoDateString});
// 						dispatch({ type: "SUBMIT", field: 'dateOfBirth'});
					} else {
						// Handle invalid date or null value
						console.log('Error setting date');
// 						dispatch({type: "UPDATE", field: 'dateOfBirth', value: null});
					}
				} catch {
					console.log('catch');
				}
			}}

				sx = {{
					'& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root': {
						maxHeight: '50px',
						width: '100%',
						border: '1px solid lightgray !important',
						fontSize: '1.1rem',
					},


					'& .css-1bn53lx': {
						maxHeight: '50px',
						maxWidth: '100%',
						border: '1px solid gray',
						fontSize: '1.1rem',
// 						marginLeft: '16px',
					},



					'& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
						border: 'none',
					},

					'& .css-igs3ac': {
						border: 'none',
					}

					
				}}

				slotProps={{ 
					textField: { 
						placeholder: lang.dateOfBirth,
					} 
				}}
			/>
}
			</LocalizationProvider>
			<Button sx={{width: 150}}
				onClick={() => dispatch({ type: "EDIT", field: 'dateOfBirth' })} disabled={formState['dateOfBirth']?.editable}>{lang.edit}</Button>	


		</div>
		
		<div className='profile-block'>

			<label for='nationalities' className='quad-title'>{lang.nationalities}</label>
			<Select
				options={countries.en}
				value={formState?.countriesOfCitizenship?.value}
				onChange={selectedOption => {
					dispatch({type: "UPDATE", field: 'countriesOfCitizenship', value: selectedOption});
				}}

				classNamePrefix='form-text-item'
				className='form-select-dropdown'
				placeholder={lang.countriesOfCitizenship}
				isMulti={true}
				isDisabled={!formState?.countriesOfCitizenship?.editable}
				styles={{ container: (base) => ({ ...base, width: '103%', marginLeft: -8}) }} 

			>
			</Select>
			<Button 
				onClick={() => dispatch({ type: "EDIT", field: 'countriesOfCitizenship' })} disabled={formState['countriesOfCitizenship']?.editable}
				sx={{width: 150}}
			>{lang.edit}</Button>



			<label for='country-of-birth' className='quad-title'>{lang.countryOfBirth} :</label>
			<Select
				options={countries.en}
				value={formState?.countryOfBirth?.value}
				onChange={selectedOption => {
					dispatch({type: "UPDATE", field: 'countryOfBirth', value: selectedOption});
				}}

				className='form-select-dropdown'
				placeholder={lang.countryOfBirth}
				isDisabled={!formState?.countryOfBirth?.editable}
				styles={{ container: (base) => ({ ...base, width: '103%', marginLeft: -8}) }} 

			>
			</Select>
			<Button 
				onClick={() => dispatch({ type: "EDIT", field: 'countryOfBirth' })} disabled={formState['countryOfBirth']?.editable}
				sx={{width: 150}}
			>{lang.edit}</Button>

			<label for='place-of-birth' className='quad-title'>{lang.placeOfBirth} :</label>
			<TextField 
				size='small'
				value={formState?.placeOfBirth?.value}
				onChange={(e) => dispatch({ type: "UPDATE", field: 'placeOfBirth', value: e.target.value })}
				onKeyDown={(e) => e.key === "Enter" && dispatch({ type: "SUBMIT", field: 'placeOfBirth' })}
				disabled={!formState['placeOfBirth']?.editable}
			/>
			<Button 
				onClick={() => dispatch({ type: "EDIT", field: 'placeOfBirth' })} disabled={formState['placeOfBirth']?.editable}
				sx={{width: 150}}
			>{lang.edit}</Button>

			<label for='legal-gender' className='quad-title'>{lang.gender} </label>
			<Select
				options={lang.legalGenderOptions}
				onChange={selectedOption => {
					dispatch({type: "UPDATE", field: 'gender', value: selectedOption});
					dispatch({ type: "SUBMIT", field: 'gender'});
				}}
				value={formState?.gender?.value}
				placeholder={lang.gender}
				isDisabled={!formState?.gender?.editable}
			>
			</Select>

			<Button 
				sx={{width: 150}}
				onClick={() => dispatch({ type: "EDIT", field: 'gender' })} disabled={formState['gender']?.editable}
			>{lang.edit}</Button>	



			<label for='civilStatus' className='quad-title'>{lang.civilStatus} :</label>
			<Select
				menuPortalTarget={document.body}
				options={lang.civilStatusOptions}
				value={formState?.civilStatus?.value}
				onChange={selectedOption => {
					dispatch({type: "UPDATE", field: 'civilStatus', value: selectedOption});
				}}

				classNamePrefix='form-text-item'
				className='form-select-dropdown'
				placeholder="Civil Status..."
				isDisabled={!formState?.civilStatus?.editable}
				styles={{ container: (base) => ({ ...base, width: '103%', marginLeft: -8}) }} 

			>
			</Select>
			<Button 
				onClick={() => dispatch({ type: "EDIT", field: 'civilStatus' })} disabled={formState['civilStatus']?.editable}
				sx={{width: 150}}
			>{lang.edit}</Button>


			<label for='email' className='quad-title'>{lang.email} :</label>
			<p id='email' className='p-gray basic-flex nowrap'>{curUser?.email}</p>
			<p></p>




			<label for='password' className='quad-title'>{lang.password}</label>
			<div>
			<Button 
				className='basic-flex'
				sx ={{
					fontSize: 16,
					fontFamily: 'inherit',
					fontWeight: 600,
					textTransform: 'none',
					borderRadius: 5,
					width: 150,
				}}
				onClick={
					() => {
						resetPassword(curUser.email);
						showAlert();
					}
				} 
			>
			
				{lang.passwordRecovery}
			</Button>
			<div className={`${isVisible} little-popup`} style={{fontSize: '1rem'}}>{lang.resetEmailSent}</div>
			</div>
		</div>
		
			</div>
			<Spacer />
			<div className='center-flex'>
			<Button
				variant="contained" 
				className='grow-and-shrink-slightly'
				sx={{
					minHeight:  40,
					minWidth: 200,
					borderRadius: 5,
					padding: 2,
					fontSize: 20,
					textTransform: "none",
					fontFamily: "inherit",
					fontWeight: 400,
				}}
				onClick={ () => {
					const newBasicInfo = Object.fromEntries(
						Object.entries(formState).map(([key, value]) => [ key, value.value ])
					);
// 					console.log('newUserData', newBasicInfo);
					const newUserData = {
						...curUser,
						basicInfo: {...newBasicInfo}
					}
					console.log('newUserData', newUserData)
					setUser(newUserData);

				}}
			>Save</Button>
			</div>

			{
// 			<div className='center-flex'>
// 				<p className='p-gray'>{lang.changeImmutableInfo}<Link to='/contact' className='blue-link'>&nbsp;&nbsp;{lang.contactUs}</Link></p>
// 			</div>
			}

		</div>

		<Spacer />

	</div>

	);
}
